import React from 'react'
import './index.less'
import jump from 'src/helper/jumpToApp'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle } from 'src/helper/tool'
import { history } from 'src/core/router'
import brower from 'src/helper/brower'

const { appLink } = jump
const { AppStore, androidAPK, googlePlay } = appLink

@inject('store')
@observer
export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    this.homeStore = this.props.store.register('home/index')
  }

  async componentWillMount() {
    this.homeStore.GetLang(this.props.location.query)
  }

  componentDidMount() {
    setDocumentTitle(`App`)
  }

  render() {
    let { lang, language } = this.homeStore.data
    let { rc } = this.props.location.query
    let { cont } = {
      cont: {
        title: 'Yayya Daily Tasks',
        lasttime: '12:14:59 left to receive daily prizes!',
        bday1: '7days',
        bday2: '15days',
        bday3: '24days',
        cont1: 'Check-in (1/1)',
        cont2: 'Share to social media (0/3)',
        cont2icon: '+30icons',
        cont3: 'Take Speaker for 10 minutes (0/1)',
        cont3icon: '+10icons',
        cont4: 'Send ten "like" gifts to speakers (0/10)',
        cont4icon: '+10icons',
        cont5: 'Send ten "rose" gifts to speakers (0/10)',
        cont5icon: '+10icons',
        cont6: 'Stay in a room for 15 minutes (0/15)',
        cont6icon: '+15icons',
        tip: 'Copyrights of the Activity Belong to hoby'
      }
    }
    return (
      <div className="img750">
        <div className="homeApp">
          <img className="banner" src="/img/activity/dailytasks/banner.png" />
          <div className="titlediv">
            <div className="title">{cont.title}</div>
          </div>
          <div className="tipbac">
            <div className="tipdiv">{cont.lasttime}</div>
          </div>
          <div className="jindudiv">
            <div className="jindu">
              <img className="jinduimg" src="/img/activity/dailytasks/jindu.png" />
              <img className="baxiang" src="/img/activity/dailytasks/sta.png" />
              <img className="baxiang1" src="/img/activity/dailytasks/bao.png" />
              <div className="baxiangtext1">{cont.bday1}</div>
              <img className="baxiang2" src="/img/activity/dailytasks/bao.png" />
              <div className="baxiangtext2">{cont.bday2}</div>
              <img className="baxiang3" src="/img/activity/dailytasks/bao.png" />
              <div className="baxiangtext3">{cont.bday3}</div>
            </div>
          </div>
          <div className="condiv">
            <div className="conbac">
              <img className="cimg" src="/img/activity/dailytasks/rili.png" />
            </div>
            <div className="conplay">
              <div className="conText">
                <div className="conT1">{cont.cont1}</div>
              </div>
            </div>
            <div className="conBtnDiv">
              <div className="conBtn">Done</div>
            </div>
          </div>
          <div className="divh"></div>
          <div className="condiv">
            <div className="conbac">
              <img className="cimg" src="/img/activity/dailytasks/fenxiang.png" />
            </div>
            <div className="conplay">
              <div className="conText">
                <div className="conT1">
                  {cont.cont2}
                  <span className="tcol">{cont.cont2icon}</span>
                </div>
              </div>
            </div>
            <div className="conBtnDiv">
              <div className="conBtn">Share</div>
            </div>
          </div>
          <div className="divh"></div>
          <div className="condiv">
            <div className="conbac">
              <img className="cimg" src="/img/activity/dailytasks/maikefeng.png" />
            </div>
            <div className="conplay">
              <div className="conText">
                <div className="conT1">
                  {cont.cont3}
                  <span className="tcol">{cont.cont3icon}</span>
                </div>
              </div>
            </div>
            <div className="conBtnDiv">
              <div className="conBtn">Go</div>
            </div>
          </div>
          <div className="divh"></div>
          <div className="condiv">
            <div className="conbac">
              <img className="cimg" src="/img/activity/dailytasks/like.png" />
            </div>
            <div className="conplay">
              <div className="conText">
                <div className="conT1">
                  {cont.cont4}
                  <span className="tcol">{cont.cont4icon}</span>
                </div>
              </div>
            </div>
            <div className="conBtnDiv">
              <div className="conBtn">Go</div>
            </div>
          </div>
          <div className="divh"></div>
          <div className="condiv">
            <div className="conbac">
              <img className="cimg" src="/img/activity/dailytasks/liwu.png" />
            </div>
            <div className="conplay">
              <div className="conText">
                <div className="conT1">
                  {cont.cont5}
                  <span className="tcol">{cont.cont5icon}</span>
                </div>
              </div>
            </div>
            <div className="conBtnDiv">
              <div className="conBtn">Go</div>
            </div>
          </div>
          <div className="divh"></div>
          <div className="condiv">
            <div className="conbac">
              <img className="cimg" src="/img/activity/dailytasks/huihua.png" />
            </div>
            <div className="conplay">
              <div className="conText">
                <div className="conT1">
                  {cont.cont6}
                  <span className="tcol">{cont.cont6icon}</span>
                </div>
              </div>
            </div>
            <div className="conBtnDiv">
              <div className="conBtn">Go</div>
            </div>
          </div>
          <div className="bottom">
            <div className="bomdiv">
              <div className="bomtext">{cont.tip}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/dailytasks/index.js